import React from 'react';

import styles from './Phone.module.css'
import {phoneIcon} from "../../assets/icons/icons.ts";
import {formatPhoneNumber, PUBLIC_PHONE} from "../../utils/formatters/index.ts";
import {cn} from "../../utils/cn.ts";

interface Props {
    number?: string;
    showIcon?: boolean;
    numberClassName?: string
}

export const Phone: React.FC<Props> = ({number = PUBLIC_PHONE, numberClassName,  showIcon = true}) => {
    const formattedPhone = formatPhoneNumber(number)

    return (
        <div className={cn(styles.phone)}>
            {showIcon && (<img src={phoneIcon} alt='Телефон'/>)}
            <a className={numberClassName} href={`tel:+${number}`}>{formattedPhone}</a>
        </div>
    );
};